<template>
  <div class="profile-page">
    <div class="page-container">
      <!-- 顶部 -->
      <div class="page-header">
        <div class="brand">
          <img class="profile-home-logo" src="@/assets/header-logo.png" alt="DDD-DAYZ" @click="$router.push('/servers').catch(() => {})" />
          <div>
            <div class="title">个人信息</div>
          </div>
        </div>
        <div class="right">
          <el-button
            size="mini"
            @click="goBack"
            style="margin-right: 8px;"
          >返回</el-button>
          <el-button
            type="text"
            class="logout-btn"
            @click="logout"
          >退出登录</el-button>
        </div>
      </div>

      <!-- 用户卡片 -->
      <div class="user-card">
        <div class="uc-left">
          <div class="avatar">
            <span>{{ (user && user.nickname ? user.nickname[0] : '你') }}</span>
          </div>
          <div class="info">
            <div class="nick">{{ user && user.nickname || '幸存者' }}</div>
            <div class="steam">SteamID: {{ user && user.steamId || '——' }}</div>
          </div>
        </div>

        <div class="uc-right">
          <div class="points-display">
            <div class="pd-title">总{{ pointsName }}</div>
            <div class="pd-value mono">{{ fmtNumber(totalPoints) }}</div>
          </div>
          <div class="points-display points-display--diamonds">
            <div class="pd-title">总{{ diamondsName }}</div>
            <div class="pd-value mono">{{ fmtNumber(totalDiamonds) }}</div>
          </div>
        </div>
      </div>

      <!-- 各服务器积分 -->
      <div class="server-points">
        <div class="sp-header">
          <div class="sp-title">赞助信息</div>
          <div class="sp-actions">
            <el-button
              :loading="loadingServers || loadingBalances"
              icon="el-icon-refresh"
              @click="init"
              size="mini"
            >刷新</el-button>
          </div>
        </div>

        <div class="sp-list" v-loading="loadingServers || loadingBalances">
          <div class="sp-item" v-for="(s, i) in shopEnabledServers" :key="s.serverId || i">
            <div class="spi-left">
              <div class="spi-name">{{ s.serverName }}</div>
              <div class="spi-tag">{{ s.tag }}</div>
            </div>
            <div class="spi-right">
              <span class="spi-points mono">{{ fmtNumber(pointsByServer[s.serverCode] || 0) }} {{ pointsName }}</span>
              <span class="spi-diamonds mono">{{ fmtNumber(diamondsByServer[s.serverCode] || 0) }} {{ diamondsName }}</span>
            </div>
          </div>

          <div v-if="shopEnabledServers.length === 0" class="empty-tip">暂无服务器数据</div>
        </div>
      </div>

      <!-- 购买记录区块 -->
      <div class="orders-card">
        <div class="oc-header">
          <div class="oc-title">购买记录</div>
        </div>

        <div class="locked-mask" v-if="locked">
          <div class="lock-box">
            <div class="lock-icon">🔒</div>
            <div class="lock-title">已加密</div>
            <div class="lock-sub">输入支付口令解锁</div>
            <div class="lock-actions">
              <el-button type="primary" @click="openUnlock">解锁</el-button>
            </div>
          </div>
        </div>

        <div v-else class="orders-tabs-wrapper">
          <div class="orders-tabs-shell">
            <el-tabs v-model="orderTab" class="orders-tabs pill-tabs">
              <el-tab-pane label="普通订单" name="normal">
              <div class="oc-actions">
                <el-select
                  clearable
                  placeholder="按服务器筛选"
                  v-model="ordersServerCode"
                  size="small"
                  style="width: 180px; margin-right: 8px"
                  @change="onServerChanged"
                >
                  <el-option
                    v-for="s in servers"
                    :key="s.serverCode"
                    :label="s.serverName"
                    :value="s.serverCode"
                  />
                </el-select>

                <el-input
                  v-model.trim="ordersKeyword"
                  size="small"
                  clearable
                  placeholder="物品/订单/CDK"
                  style="width: 200px; margin-right: 8px;"
                  @keyup.enter.native="applyOrderFilters"
                />
                <el-checkbox
                  v-model="onlyVehicle"
                  @change="applyOrderFilters"
                  style="margin-right: 8px;"
                >只看车辆</el-checkbox>

                <el-button size="small" @click="applyOrderFilters">筛选</el-button>
                <el-button size="small" @click="clearOrderFilters">清空</el-button>
              </div>

              <div class="orders-content" v-loading="ordersLoading">
                <div class="purchase-item" v-for="(p, idx) in pageOrders" :key="p.orderId || idx">
                  <div class="pi-left">
                    <div class="pi-time">{{ formatTime(p.createdAt) }}</div>
                    <div class="pi-server">服务器:{{ p.serverName }}</div>
                  </div>

                  <div class="pi-mid">
                    <div class="pi-name" :title="p.goodsName">{{ p.goodsName }}</div>
                    <div class="pi-cdk">
                      <span class="cdk mono">{{ p.cdk }}</span>
                      <el-link type="primary" :underline="false" @click="copyCDK(p.cdk)">复制</el-link>
                      <el-button
                        v-if="p.isVehicle == 1"
                        type="warning"
                        size="mini"
                        :loading="!!applying[p.orderId]"
                        @click="handleApplyVehicle(p)"
                      >申请补车</el-button>
                    </div>
                  </div>

                  <div class="pi-right">
                    <span class="price-chip">-{{ formatOrderPrice(p) }}</span>
                  </div>
                </div>

                <div v-if="filteredOrders.length === 0" class="empty-tip">暂无购买记录</div>

                <div class="orders-pagination" v-if="filteredOrders.length > 0">
                  <el-pagination
                    background
                    layout="sizes, prev, pager, next, jumper, ->, total"
                    :current-page="ordersPage"
                    :page-size="ordersSize"
                    :page-sizes="pageSizes"
                    :total="filteredOrders.length"
                    @size-change="onOrdersSizeChange"
                    @current-change="onOrdersPageChange"
                  />
                </div>
              </div>
            </el-tab-pane>

              <el-tab-pane label="载具保险" name="insurance">
              <div class="oc-actions">
                <el-select
                  clearable
                  placeholder="按服务器筛选"
                  v-model="insuranceServerCode"
                  size="small"
                  style="width: 180px; margin-right: 8px"
                  @change="onInsuranceServerChanged"
                >
                  <el-option
                    v-for="s in servers"
                    :key="s.serverCode"
                    :label="s.serverName"
                    :value="s.serverCode"
                  />
                </el-select>

                <el-input
                  v-model.trim="insuranceKeyword"
                  size="small"
                  clearable
                  placeholder="车辆/订单/CDK"
                  style="width: 200px; margin-right: 8px;"
                  @keyup.enter.native="applyInsuranceFilters"
                />

                <el-button size="small" @click="applyInsuranceFilters">筛选</el-button>
                <el-button size="small" @click="clearInsuranceFilters">清空</el-button>
              </div>

              <div class="orders-content" v-loading="insuranceLoading">
                <div class="purchase-item" v-for="(p, idx) in pageInsuranceOrders" :key="p.id || idx">
                  <div class="pi-left">
                    <div class="pi-time">{{ formatTime(p.createdAt || p.usedAt) }}</div>
                    <div class="pi-server">服务器:{{ p.serverName }}</div>
                  </div>

                  <div class="pi-mid">
                    <div class="pi-name">{{ p.goodsName }} · {{ p.classname }}</div>
                    <div class="pi-cdk">
                      <span class="cdk mono">{{ p.cdk }}</span>
                      <el-link type="primary" :underline="false" @click="copyCDK(p.cdk)">复制</el-link>
                      <el-button
                        v-if="p.orderId"
                        type="warning"
                        size="mini"
                        :loading="!!applying[p.orderId]"
                        @click="handleApplyVehicle(p)"
                      >申请补车</el-button>
                    </div>
                    <div class="pi-attachments" v-if="p.attachments && p.attachments.length">
                      附件：{{ p.attachments.join('、') }}
                    </div>
                  </div>

                  <div class="pi-right">
                    <span class="price-chip">保险CDK</span>
                  </div>
                </div>

                <div v-if="filteredInsuranceOrders.length === 0" class="empty-tip">暂无保险记录</div>

                <div class="orders-pagination" v-if="filteredInsuranceOrders.length > 0">
                  <el-pagination
                    background
                    layout="sizes, prev, pager, next, jumper, ->, total"
                    :current-page="insurancePage"
                    :page-size="insuranceSize"
                    :page-sizes="pageSizes"
                    :total="filteredInsuranceOrders.length"
                    @size-change="onInsuranceSizeChange"
                    @current-change="onInsurancePageChange"
                  />
                </div>
              </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- 解锁弹窗：样式保持你自定义的 apoc-dialog -->
    <el-dialog
      title="解锁购买记录"
      :visible.sync="unlockVisible"
      width="420px"
      :close-on-click-modal="false"
      custom-class="apoc-dialog apoc-dialog--prompt"
    >
      <p>请输入你的支付口令以解锁</p>
      <el-input
        v-model.trim="payPass"
        show-password
        placeholder="输入支付口令"
        maxlength="50"
        @keyup.enter.native="confirmUnlock"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="unlockVisible=false" :disabled="unlockLoading">取消</el-button>
        <el-button type="primary" @click="confirmUnlock" :loading="unlockLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { session, unPersist } from '@/store/session'
import { siteConfigState, ensureSiteConfig, currencyName } from '@/store/site-config'

export default {
  name: 'PersonalInfo',
  data () {
    return {
      /* —— 服务器 & 积分 —— */
      servers: [],
      balances: [],
      pointsByServer: {},
      diamondsByServer: {},
      loadingServers: false,
      loadingBalances: false,

      /* —— 订单 —— */
      orderTab: 'normal',
      locked: true,
      unlockVisible: false,
      payPass: '',
      unlockLoading: false,

      // 原始所有订单（当前 serverCode 下，已全部拉全）
      rawOrders: [],
      // 过滤后的订单（用于分页显示）
      filteredOrders: [],

      ordersPage: 1,
      ordersSize: 10,
      ordersServerCode: '',
      ordersLoading: false,
      pageSizes: [10, 20, 50],

      // 简单筛选
      ordersKeyword: '',
      onlyVehicle: false,

      // 车辆保险订单
      insuranceLoading: false,
      insuranceServerCode: '',
      insuranceKeyword: '',
      insurancePage: 1,
      insuranceSize: 10,
      rawInsuranceOrders: [],
      filteredInsuranceOrders: [],

      // 行内 loading（申请补车）
      applying: {}
    }
  },
  computed: {
    user () { return session.user },
    pointsName () { return siteConfigState.pointsName },
    diamondsName () { return siteConfigState.diamondsName },
    totalPoints () {
      if (!this.balances || this.balances.length === 0) return 0
      return this.balances.reduce((sum, b) => sum + (Number(b?.points) || 0), 0)
    },
    totalDiamonds () {
      if (!this.balances || this.balances.length === 0) return 0
      return this.balances.reduce((sum, b) => sum + (Number(b?.diamonds) || 0), 0)
    },
    shopEnabledServers () {
      if (!Array.isArray(this.servers)) return []
      return this.servers.filter(s => s && s.shopEnabled)
    },
    // totalDiamonds () {
    //   if (!this.balances || this.balances.length === 0) return 0
    //   let sum = 0
    //   for (let i = 0; i < this.balances.length; i++) {
    //     const b = this.balances[i]
    //     sum += (b && typeof b.diamondBalance === 'number') ? b.diamondBalance : 0
    //   }
    //   return sum
    // },
    pageOrders () {
      const start = (this.ordersPage - 1) * this.ordersSize
      const end = start + this.ordersSize
      return this.filteredOrders.slice(start, end)
    },
    pageInsuranceOrders () {
      const start = (this.insurancePage - 1) * this.insuranceSize
      const end = start + this.insuranceSize
      return this.filteredInsuranceOrders.slice(start, end)
    }
  },
  created () {
    ensureSiteConfig()
    this.init()
  },
  methods: {
    currencyLabel (currency) {
      return currencyName(currency)
    },
    /* ===== 初始化:服务器列表 + 各服务器余额 ===== */
    async init () {
      await this.fetchServers()
      await this.fetchAllBalances()
    },

    async fetchServers () {
      this.loadingServers = true
      try {
        const r = await api.getServers()
        const items = (r && r.items) ? r.items : (Array.isArray(r) ? r : [])
        this.servers = items
      } catch (e) {
        this.servers = []
        this.$message.error(e.message || '获取服务器列表失败')
      } finally {
        this.loadingServers = false
      }
    },

    async fetchAllBalances () {
      this.loadingBalances = true
      try {
        const tasks = this.shopEnabledServers.map(s => (async () => {
          try {
            const r = await api.getWalletBalance(s.serverCode)
            const points = (r && typeof r.balancePoints === 'number')
              ? r.balancePoints
              : ((r && typeof r.balance === 'number') ? r.balance : (typeof r === 'number' ? r : 0))
            const diamonds = (r && typeof r.balanceDiamonds === 'number') ? r.balanceDiamonds : 0
            return { serverCode: s.serverCode, points, diamonds }
          } catch (e) {
            return { serverCode: s.serverCode, points: 0, diamonds: 0 }
          }
        })())
        const results = await Promise.all(tasks)
        const pointMap = {}
        const diamondMap = {}
        for (let i = 0; i < results.length; i++) {
          const it = results[i]
          pointMap[it.serverCode] = it.points
          diamondMap[it.serverCode] = it.diamonds
        }
        this.balances = results
        this.pointsByServer = pointMap
        this.diamondsByServer = diamondMap
      } catch (e) {
        this.balances = []
        this.pointsByServer = {}
        this.diamondsByServer = {}
        this.$message.error(e.message || '获取余额失败')
      } finally {
        this.loadingBalances = false
      }
    },
    getPointsBalanceFromResp (resp) {
      if (resp == null) return 0
      if (typeof resp === 'number') return resp
      const val = resp.balance != null ? resp.balance : resp.points
      const num = Number(val)
      return Number.isFinite(num) ? num : 0
    },
    getDiamondBalanceFromResp (resp) {
      if (!resp || typeof resp === 'number') return 0
      const val = resp.diamondBalance != null ? resp.diamondBalance : resp.diamonds
      const num = Number(val)
      return Number.isFinite(num) ? num : 0
    },

    /* ===== 订单：获取 / 过滤 / 分页 ===== */
    openUnlock () {
      this.unlockVisible = true
      this.$nextTick(() => {
        try {
          const el = this.$el.querySelector('.apoc-dialog .el-input__inner')
          if (el) el.focus()
        } catch (e) {}
      })
    },

    async confirmUnlock () {
      if (!this.payPass) {
        this.$message.warning('请输入支付口令')
        return
      }
      this.unlockLoading = true
      try {
        await Promise.all([this.reloadAllOrders(), this.reloadInsuranceOrders()])
        this.locked = false
        this.unlockVisible = false
      } catch (e) {
        // 提示已在内部做
      } finally {
        this.unlockLoading = false
      }
    },

    // 切换服务器：重新拉取该服所有订单
    async onServerChanged () {
      if (this.locked) {
        this.openUnlock()
        return
      }
      await this.reloadAllOrders()
    },

    async onInsuranceServerChanged () {
      if (this.locked) {
        this.openUnlock()
        return
      }
      await this.reloadInsuranceOrders()
    },

    // 拉取当前 serverCode 的“全部订单”（自动翻页拉全），保证后续的简单筛选一定生效
    async reloadAllOrders () {
      this.ordersLoading = true
      try {
        const pageSize = 100
        let page = 1
        let total = Infinity
        const all = []
        // 循环翻页，直到抓满 total 或没有更多
        while (all.length < total) {
          const res = await api.getMyOrders(this.payPass, {
            page,
            size: pageSize,
            serverCode: this.ordersServerCode || undefined
          })
          const items = (res && res.items) ? res.items : (Array.isArray(res) ? res : [])
          const t = (res && res.total != null) ? Number(res.total) : (Array.isArray(res) ? items.length : 0)
          total = isNaN(t) ? items.length : t

          for (let i = 0; i < items.length; i++) all.push(items[i])

          if (items.length < pageSize) break
          page++
        }
        this.rawOrders = all
        this.ordersPage = 1
        this.applyOrderFilters()
      } catch (e) {
        this.$message.error(e.message || '获取购买记录失败')
        throw e
      } finally {
        this.ordersLoading = false
      }
    },

    async reloadInsuranceOrders () {
      this.insuranceLoading = true
      try {
        const pageSize = 100
        let page = 1
        let total = Infinity
        const all = []
        while (all.length < total) {
          const res = await api.getMyInsuranceOrders(this.payPass, {
            page,
            size: pageSize,
            serverCode: this.insuranceServerCode || undefined
          })
          const items = (res && res.items) ? res.items : (Array.isArray(res) ? res : [])
          const t = (res && res.total != null) ? Number(res.total) : (Array.isArray(res) ? items.length : 0)
          total = isNaN(t) ? items.length : t

          for (let i = 0; i < items.length; i++) all.push(items[i])
          if (items.length < pageSize) break
          page++
        }
        this.rawInsuranceOrders = all
        this.insurancePage = 1
        this.applyInsuranceFilters()
      } catch (e) {
        this.$message.error(e.message || '获取车辆保险记录失败')
        throw e
      } finally {
        this.insuranceLoading = false
      }
    },

    applyOrderFilters () {
      // 简单筛选：关键词 + 只看车辆
      const kw = (this.ordersKeyword || '').toLowerCase()
      const onlyCar = !!this.onlyVehicle
      let arr = this.rawOrders.slice()

      if (onlyCar) {
        arr = arr.filter(x => String(x.isVehicle) === '1')
      }
      if (kw) {
        arr = arr.filter(x => {
          const o = (x.orderId != null) ? String(x.orderId) : ''
          const g = (x.goodsName || '').toLowerCase()
          const c = (x.cdk || '').toLowerCase()
          return o.includes(this.ordersKeyword) || g.includes(kw) || c.includes(kw)
        })
      }
      this.filteredOrders = arr
      // 过滤后从第一页开始
      this.ordersPage = 1
    },

    applyInsuranceFilters () {
      const kw = (this.insuranceKeyword || '').toLowerCase()
      let arr = this.rawInsuranceOrders.slice()
      if (kw) {
        arr = arr.filter(x => {
          const orderId = (x.orderId != null) ? String(x.orderId) : ''
          const cls = (x.classname || '').toLowerCase()
          const cdk = (x.cdk || '').toLowerCase()
          return orderId.includes(this.insuranceKeyword) || cls.includes(kw) || cdk.includes(kw)
        })
      }
      this.filteredInsuranceOrders = arr
      this.insurancePage = 1
    },

    clearOrderFilters () {
      this.ordersServerCode = ''
      this.ordersKeyword = ''
      this.onlyVehicle = false
      this.reloadAllOrders()
    },

    clearInsuranceFilters () {
      this.insuranceServerCode = ''
      this.insuranceKeyword = ''
      this.reloadInsuranceOrders()
    },

    onOrdersPageChange (p) {
      this.ordersPage = p
    },

    onOrdersSizeChange (s) {
      this.ordersSize = s
      this.ordersPage = 1
    },

    onInsurancePageChange (p) {
      this.insurancePage = p
    },

    onInsuranceSizeChange (s) {
      this.insuranceSize = s
      this.insurancePage = 1
    },

    isDiamondOrder (order) {
      if (!order) return false
      if (order.currency) return String(order.currency).toLowerCase() === 'diamonds'
      if (order.priceDiamonds != null) {
        const num = Number(order.priceDiamonds)
        return Number.isFinite(num) && num > 0
      }
      return false
    },
    formatOrderCost (order) {
      if (!order) return ''
      if (this.isDiamondOrder(order)) {
        const val = order.priceDiamonds != null ? order.priceDiamonds : order.costDiamonds
        const num = Number(val)
        const amount = Number.isFinite(num) ? num : 0
        return `-${amount} ${this.diamondsName}`
      }
      const val = order.pricePoints != null ? order.pricePoints : order.price
      const num = Number(val)
      const amount = Number.isFinite(num) ? num : 0
      return `-${amount} ${this.pointsName}`
    },
    priceChipClass (order) {
      return this.isDiamondOrder(order) ? 'price-chip--diamond' : ''
    },

    /* ===== 其它工具方法 ===== */
    copyCDK (cdk) {
      if (!cdk) return
      const done = () => this.$message.success('已复制到剪贴板')
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(cdk).then(done).catch(() => {
            const t = document.createElement('textarea')
            t.value = cdk
            document.body.appendChild(t)
            t.select()
            document.execCommand('copy')
            document.body.removeChild(t)
            done()
          })
        } else {
          const t = document.createElement('textarea')
          t.value = cdk
          document.body.appendChild(t)
          t.select()
          document.execCommand('copy')
          document.body.removeChild(t)
          done()
        }
      } catch (e) {
        this.$message.error('复制失败，请手动选择文本复制')
      }
    },

    formatTime (iso) {
      if (!iso) return '——'
      try {
        const d = new Date(iso)
        const y = d.getFullYear()
        const m = (d.getMonth() + 1).toString().padStart(2, '0')
        const dd = d.getDate().toString().padStart(2, '0')
        const hh = d.getHours().toString().padStart(2, '0')
        const mm = d.getMinutes().toString().padStart(2, '0')
        const ss = d.getSeconds().toString().padStart(2, '0')
        return `${y}-${m}-${dd} ${hh}:${mm}:${ss}`
      } catch (e) {
        return iso
      }
    },

    logout () {
      session.token = null
      session.user = null
      unPersist()
      this.$message.success('已退出登录')
      this.$router.replace('/servers')
    },

    // 申请补车（车辆订单才显示按钮）
    async handleApplyVehicle (p) {
      try {
        await this.$confirm(
          `确定要为订单【${p.orderId}】申请补车吗？`,
          '确认申请',
          { type: 'warning', customClass: 'apoc-confirm' }
        )

        this.$set(this.applying, p.orderId, true)

        const res = await api.applyVehicle(p.orderId, { serverCode: p.serverCode })
        // 兼容 index.js 里 .then(r => r.data || r) 的两种形状
        const payload = (res && res.data) ? res.data : res
        const success = (typeof payload?.success === 'boolean') ? payload.success : true // 200 视为成功
        const msg = payload?.message || (success
          ? '申请已提交，请等待管理员审核'
          : '申请失败，请稍后重试')

        if (success) {
          this.$message.success(msg)
        } else {
          this.$message.error(msg)
        }
      } catch (e) {
        // 用户取消/关闭弹框不提示错误
        if (e !== 'cancel' && e !== 'close') {
          // 兼容 axios 拦截：400 返回 {message}，以及常规 Error.message
          const msg =
            (e && e.message) ||
            (e && e.response && e.response.data && e.response.data.message) ||
            '申请失败，请稍后重试'
          this.$message.error(msg)
        }
      } finally {
        this.$set(this.applying, p.orderId, false)
      }
    },

    fmtNumber (v) {
      const num = Number(v)
      if (Number.isFinite(num)) return num.toLocaleString()
      return v == null ? '0' : String(v)
    },
    formatOrderPrice (p) {
      if (!p) return `0 ${this.pointsName}`
      const currency = (p.currency || '').toLowerCase()
      if (currency === 'diamonds') {
        const val = Number(p.priceDiamonds)
        return `${Number.isFinite(val) ? val : 0} ${this.diamondsName}`
      }
      const val = Number(p.pricePoints)
      return `${Number.isFinite(val) ? val : 0} ${this.pointsName}`
    },

    goBack () {
      // 优先返回来源路由（如果有）
      if (this.$route && this.$route.query && this.$route.query.from) {
        this.$router.push(this.$route.query.from)
        return
      }
      // 有历史就后退；没有就回到服务器列表（按你的路由改 fallback 即可）
      const fallback = '/servers'
      if (window.history.length > 1) this.$router.back()
      else this.$router.push(fallback)
    }
  }
}
</script>

<style scoped>
/* ===== 背景与末日质感(柔和) ===== */
.profile-page {
  min-height: 100vh;
  background:
    radial-gradient(1200px 800px at 80% -10%, rgba(119, 217, 84, 0.06), transparent 60%),
    radial-gradient(900px 600px at -10% 110%, rgba(34, 211, 238, 0.05), transparent 60%),
    #0b1320;
  color: #a9bac6;
  position: relative;
  overflow-x: hidden;
}
.page-container { max-width: 980px; margin: 0 auto; padding: 20px 16px 48px; }

/* 顶部 */
.page-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 18px; }
.brand { display: flex; align-items: center; gap: 12px; }
.logo { width: 28px; height: 28px; border-radius: 8px; background: linear-gradient(135deg,#22d3ee,#22d3ee44); box-shadow: 0 0 14px rgba(34,211,238,0.32); }
.title { font-weight: 700; font-size: 18px; color: #e2f0ff; }
.sub { font-size: 12px; color: #7f93a2; margin-top: 4px; }
.logout-btn { color: #90e975; }

/* 用户卡片 */
.user-card {
  display: grid; grid-template-columns: 1fr auto; gap: 16px;
  background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 16px;
  padding: 16px; margin-bottom: 16px;
}
.uc-left { display: flex; align-items: center; gap: 12px; }
.avatar {
  width: 56px; height: 56px; border-radius: 14px; background: rgba(34,211,238,0.1); color: #22d3ee;
  display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 22px;
}
.info .nick { font-weight: 700; color: #e8f7ff; margin-bottom: 4px; }
.info .steam { font-size: 12px; color: #7f93a2; }

.uc-right { display: flex; align-items: stretch; justify-content: flex-end; padding: 8px; gap: 12px; flex-wrap: wrap; }
.points-display {
  background: rgba(144,233,117,0.12); border: 1px solid rgba(144,233,117,0.38); border-radius: 12px;
  padding: 8px 14px; min-width: 140px; text-align: center;
  display: flex; flex-direction: column; justify-content: center;
}
.points-display--diamonds {
  background: rgba(34,211,238,0.12);
  border-color: rgba(34,211,238,0.38);
  color: #22d3ee;
}
.pd-title { font-size: 12px; color: #a7c2a8; margin-bottom: 4px; }
.pd-value { font-weight: 800; color: #a3ff12; font-size: 22px; }
.points-display--diamonds .pd-title { color: #7ad8e6; }
.points-display--diamonds .pd-value { color: #7ae9ff; }
.mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; }

/* 服务器积分 */
.server-points {
  background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 16px;
  padding: 16px; margin-bottom: 16px;
}
.sp-header { display: flex; align-items: center; justify-content: space-between; padding-bottom: 10px; border-bottom: 1px dashed rgba(255,255,255,0.06); }
.sp-title { font-weight: 700; color: #e8f7ff; }
.sp-list { margin-top: 10px; }
.sp-item {
  display: grid; grid-template-columns: 1fr auto; align-items: center;
  padding: 12px; margin-bottom: 10px;
  background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 10px;
  transition: background-color 160ms ease, border-color 160ms ease;
}
.sp-item:hover { background: rgba(255,255,255,0.03); border-color: rgba(255,255,255,0.12); }
.spi-left { display: flex; align-items: center; gap: 10px; }
.spi-name { font-weight: 700; color: #d7e8ff; }
.spi-tag { font-size: 12px; color: #7f93a2; }
.spi-right { display: flex; flex-direction: column; gap: 6px; align-items: flex-end; }
.spi-right .spi-points,
.spi-right .spi-diamonds {
  font-weight: 700; text-align: center; border-radius: 8px; padding: 6px 10px; min-width: 120px;
}
.spi-right .spi-points {
  color: #0b1320; background: #a3ff12; border: 1px solid rgba(163,255,18,0.4);
}
.spi-right .spi-diamonds {
  color: #22d3ee; background: rgba(34,211,238,0.18); border: 1px solid rgba(34,211,238,0.38);
}

/* 购买记录 */
.orders-card {
  background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 16px;
  padding: 16px; position: relative;
}
.oc-header { display: flex; align-items: center; justify-content: space-between; padding-bottom: 10px; border-bottom: 1px dashed rgba(255,255,255,0.06); }
.oc-title { font-weight: 700; color: #e8f7ff; }

.locked-mask {
  position: absolute; inset: 0; backdrop-filter: blur(4px); background: rgba(11,19,32,0.52);
  display: flex; align-items: center; justify-content: center; border-radius: 16px;
}
.lock-box { text-align: center; }
.lock-icon { font-size: 32px; margin-bottom: 6px; color: #7f93a2; }
.lock-title { font-weight: 700; color: #e2f0ff; }
.lock-sub { font-size: 12px; color: #7f93a2; margin: 6px 0 12px; }

.orders-content { margin-top: 12px; }
.orders-tabs-wrapper { margin-top: 12px; }
.orders-tabs-shell {
  width: 100%;
  margin-top: 10px;
  background: transparent; /* 去掉背景，只让按钮有背景 */
  border: none;
  box-shadow: none;
  padding: 0;
}

/* 2. 核心修正：只针对“导航栏”进行居中和胶囊化，不影响内容区 */
:deep(.pill-tabs .el-tabs__nav-scroll) {
  display: flex;
  justify-content: center; /* 让 Tab 按钮居中 */
  padding-bottom: 12px; /* 给下方列表留点距离 */
}

:deep(.pill-tabs .el-tabs__nav) {
  /* 这里的样式创造了“胶囊轨道”背景 */
  background: rgba(11, 19, 32, 0.8); /* 深色轨道背景 */
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 50px; /* 大圆角，形成跑道形状 */
  padding: 4px; /* 轨道内边距 */
  display: flex;
  gap: 4px; /* 按钮之间的间隙 */
}

/* 去除 Element 默认的底部线条 */
:deep(.pill-tabs .el-tabs__nav-wrap::after),
:deep(.pill-tabs .el-tabs__active-bar) {
  display: none !important;
}

/* 3. Tab 按钮样式：自然、无边框 */
:deep(.pill-tabs .el-tabs__item) {
  height: 32px;
  line-height: 32px;
  padding: 0 24px !important; /* 左右内边距 */
  margin: 0 !important;
  border: none !important;
  border-radius: 40px; /* 按钮也随轨道变圆 */
  font-size: 13px;
  font-weight: 600;
  color: #7f93a2; /* 默认灰字 */
  background: transparent;
  transition: all 0.3s ease;
}

/* 悬停状态 */
:deep(.pill-tabs .el-tabs__item:hover) {
  color: #e2f0ff;
  background: rgba(255, 255, 255, 0.05);
}

/* 选中状态：高亮、微光背景 */
:deep(.pill-tabs .el-tabs__item.is-active) {
  color: #0b1320; /* 选中时文字变深色，增加对比度 */
  background: #a3ff12; /* 你的主色调：荧光绿背景 */
  box-shadow: 0 2px 12px rgba(163, 255, 18, 0.4); /* 绿色荧光弥散 */
  font-weight: 800;
}

/* 确保 Tab 下面的内容区域（Pane）是满宽的 */
:deep(.pill-tabs .el-tabs__content) {
  width: 100%;
  overflow: visible; /* 允许阴影溢出 */
}
.purchase-item {
  display: grid; grid-template-columns: 1fr 1.4fr auto; gap: 8px;
  padding: 12px; margin-bottom: 10px;
  background: rgba(255,255,255,0.02); border: 1px solid rgba(255,255,255,0.06); border-radius: 10px;
}
.pi-left .pi-time { font-size: 12px; color: #7f93a2; }
.pi-left .pi-server { color: #9fb0bf; }
.pi-mid .pi-name { font-weight: 700; color: #d7e8ff; margin-bottom: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pi-mid .pi-cdk { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.pi-mid .pi-attachments { color: #7f93a2; font-size: 12px; }
.cdk { color: #b4f5a8; margin-right: 8px; }

.pi-right .price-chip {
  display: inline-block; min-width: 64px; text-align: center;
  color: #0b1320; background: #a3ff12; border-radius: 8px; padding: 6px 8px; font-weight: 800;
}
.pi-right .price-chip--diamond {
  background: linear-gradient(135deg, rgba(129,140,248,0.9), rgba(192,132,252,0.9));
  color: #fdf4ff;
  box-shadow: 0 0 12px rgba(192,132,252,0.35);
}

.orders-pagination { display: flex; justify-content: flex-end; margin-top: 8px; }

.empty-tip {
  color: #7f93a2; font-size: 13px; text-align: center; padding: 18px 0;
}

/* 弹窗（保持你的自定义风格，不替换） */
.apoc-dialog :deep(.el-dialog__header) { border-bottom: 1px dashed rgba(255,255,255,0.08); }
.apoc-dialog :deep(.el-dialog__title) { color: #e2f0ff; }
.apoc-dialog :deep(.el-dialog__body) { color: #a9bac6; }
.apoc-dialog :deep(.el-dialog__footer) { border-top: 1px dashed rgba(255,255,255,0.08); }
.apoc-dialog .el-button { background: rgba(255,255,255,0.04); border-color: rgba(255,255,255,0.12); color: #e2f0ff; }
.apoc-dialog .el-button:hover,
.apoc-dialog .el-button:focus {
  background: rgba(163,255,18,0.08);
  border-color: rgba(163,255,18,0.28);
}
.apoc-dialog .el-button--primary { background: #16a34a; border-color: #16a34a; }
.apoc-dialog .el-button--primary:hover,
.apoc-dialog .el-button--primary:focus { filter: brightness(1.1); border-color: #22c55e; }

:deep(.apoc-dialog) {
  /* 覆盖默认白底 */
  background: rgba(11, 19, 32, 0.96) !important; /* #0b1320 带透明，和整页背景一致 */
  color: #e2f0ff !important;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
}

:deep(.apoc-dialog .el-dialog__header) {
  background: transparent !important;
  border-bottom: 1px dashed rgba(255,255,255,0.08);
  padding: 14px 16px;
}

:deep(.apoc-dialog .el-dialog__title) {
  color: #e2f0ff !important;
}

:deep(.apoc-dialog .el-dialog__headerbtn .el-dialog__close) {
  color: #9fb0bf !important;
}

:deep(.apoc-dialog .el-dialog__body) {
  background: transparent !important;
  color: #a9bac6 !important;
}

:deep(.apoc-dialog .el-dialog__footer) {
  background: transparent !important;
  border-top: 1px dashed rgba(255,255,255,0.08);
}

/* 输入框维持深色 */
:deep(.apoc-dialog .el-input__inner) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.apoc-dialog .el-input__inner::placeholder) {
  color: #7f93a2 !important;
}

/* 按钮维持你的深色配色 */
:deep(.apoc-dialog .el-button) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.apoc-dialog .el-button:hover),
:deep(.apoc-dialog .el-button:focus) {
  background: rgba(163,255,18,0.08) !important;
  border-color: rgba(163,255,18,0.28) !important;
}
:deep(.apoc-dialog .el-button--primary) {
  background: #16a34a !important;   /* 保持你的绿色主色 */
  border-color: #16a34a !important;
  color: #0b1320 !important;
}
:deep(.apoc-dialog .el-button--primary:hover),
:deep(.apoc-dialog .el-button--primary:focus) {
  filter: brightness(1.1);
  border-color: #22c55e !important;
}

:deep(.el-input__inner) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.el-input__inner::placeholder) { color: #7f93a2 !important; }
:deep(.el-input.is-focus .el-input__inner),
:deep(.el-input__inner:focus) {
  border-color: rgba(163,255,18,0.42) !important;
  box-shadow: 0 0 0 1px rgba(163,255,18,0.12) inset !important;
}

/* el-select 的输入框同样变深色 */
:deep(.el-select .el-input__inner) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.el-select .el-input.is-focus .el-input__inner) {
  border-color: rgba(163,255,18,0.42) !important;
  box-shadow: 0 0 0 1px rgba(163,255,18,0.12) inset !important;
}

/* el-select 下拉面板也改成深色，避免展开后是白色 */
:deep(.el-select-dropdown) {
  background: #101826 !important;
  border-color: rgba(255,255,255,0.12) !important;
}
:deep(.el-select-dropdown__item) { color: #e2f0ff !important; }
:deep(.el-select-dropdown__item.hover),
:deep(.el-select-dropdown__item.selected) {
  background: rgba(163,255,18,0.12) !important;
}

/* === 默认按钮（刷新 / 筛选 / 清空等）深色 === */
/* 不影响 primary 和 text 类型按钮 */
:deep(.el-button:not(.el-button--primary):not(.el-button--text)) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.el-button:not(.el-button--primary):not(.el-button--text):hover),
:deep(.el-button:not(.el-button--primary):not(.el-button--text):focus) {
  background: rgba(163,255,18,0.08) !important;
  border-color: rgba(163,255,18,0.28) !important;
}

/* === 复选框（只看车辆）深色 === */
:deep(.el-checkbox__inner) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.18) !important;
}
:deep(.el-checkbox.is-checked .el-checkbox__inner) {
  background: #16a34a !important;   /* 保持你的绿色主色 */
  border-color: #16a34a !important;
}
:deep(.el-checkbox__inner::after) { border-color: #0b1320 !important; } /* 深色对比的对勾 */
:deep(.el-checkbox__label) { color: #e2f0ff !important; }

/* === 保底：弹框维持深色（如果之前被覆盖，这里强制回深色） === */
:deep(.apoc-dialog) {
  background: rgba(11, 19, 32, 0.96) !important;
  color: #e2f0ff !important;
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
}
:deep(.apoc-dialog .el-dialog__header) {
  background: transparent !important;
  border-bottom: 1px dashed rgba(255,255,255,0.08);
}
:deep(.apoc-dialog .el-dialog__title) { color: #e2f0ff !important; }
:deep(.apoc-dialog .el-dialog__headerbtn .el-dialog__close) { color: #9fb0bf !important; }
:deep(.apoc-dialog .el-dialog__body) { background: transparent !important; color: #a9bac6 !important; }
:deep(.apoc-dialog .el-dialog__footer) { background: transparent !important; border-top: 1px dashed rgba(255,255,255,0.08); }
:deep(.apoc-dialog .el-input__inner) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.apoc-dialog .el-button) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.apoc-dialog .el-button:hover),
:deep(.apoc-dialog .el-button:focus) {
  background: rgba(163,255,18,0.08) !important;
  border-color: rgba(163,255,18,0.28) !important;
}
:deep(.apoc-dialog .el-button--primary) {
  background: #16a34a !important;
  border-color: #16a34a !important;
  color: #0b1320 !important;
}
:deep(.apoc-dialog .el-button--primary:hover),
:deep(.apoc-dialog .el-button--primary:focus) {
  filter: brightness(1.1);
  border-color: #22c55e !important;
}
:deep(.el-select .el-input__inner) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.el-select .el-input__inner::placeholder) { color: #7f93a2 !important; }
:deep(.el-select .el-input.is-focus .el-input__inner),
:deep(.el-select .el-input__inner:focus) {
  border-color: rgba(163,255,18,0.42) !important;
  box-shadow: 0 0 0 1px rgba(163,255,18,0.12) inset !important;
}

/* 下拉面板深色 */
:deep(.el-select-dropdown) {
  background: #101826 !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.el-select-dropdown__wrap) { background: transparent !important; }
:deep(.el-select-dropdown__item) { color: #e2f0ff !important; }
:deep(.el-select-dropdown__item.hover),
:deep(.el-select-dropdown__item.selected) {
  background: rgba(163,255,18,0.12) !important;
}
:deep(.apoc-confirm.el-message-box) {
  background: rgba(11, 19, 32, 0.96) !important; /* #0b1320 系深色 */
  color: #e2f0ff !important;
  border: 1px solid rgba(255,255,255,0.06) !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5) !important;
}
:deep(.apoc-confirm .el-message-box__title) { color: #e2f0ff !important; }
:deep(.apoc-confirm .el-message-box__content) { color: #a9bac6 !important; }
:deep(.apoc-confirm .el-message-box__headerbtn .el-message-box__close) { color: #9fb0bf !important; }
/* 按钮也用你的深色规范 */
:deep(.apoc-confirm .el-button) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.apoc-confirm .el-button:hover),
:deep(.apoc-confirm .el-button:focus) {
  background: rgba(163,255,18,0.08) !important;
  border-color: rgba(163,255,18,0.28) !important;
}
:deep(.apoc-confirm .el-button--primary) {
  background: #16a34a !important;  /* 你的绿色主色 */
  border-color: #16a34a !important;
  color: #0b1320 !important;
}
:deep(.apoc-confirm .el-button--primary:hover),
:deep(.apoc-confirm .el-button--primary:focus) {
  filter: brightness(1.1);
  border-color: #22c55e !important;
}
/* 默认按钮（非 primary / 非 text）深色 */
:deep(.el-button:not(.el-button--primary):not(.el-button--text)) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.el-button:not(.el-button--primary):not(.el-button--text):hover),
:deep(.el-button:not(.el-button--primary):not(.el-button--text):focus) {
  background: rgba(163,255,18,0.08) !important;
  border-color: rgba(163,255,18,0.28) !important;
}

/* 复选框深色 */
:deep(.el-checkbox__inner) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.18) !important;
}
:deep(.el-checkbox.is-checked .el-checkbox__inner) {
  background: #16a34a !important;
  border-color: #16a34a !important;
}
:deep(.el-checkbox__inner::after) { border-color: #0b1320 !important; }
:deep(.el-checkbox__label) { color: #e2f0ff !important; }

.avatar {
  background: rgba(163,255,18,0.12) !important; /* 黑客绿背景微光 */
  color: #a3ff12 !important;                    /* 字体黑客绿 */
}
.logo {
  background: linear-gradient(135deg, #16a34a, rgba(34,197,94,0.24)) !important;
  box-shadow: 0 0 14px rgba(163,255,18,0.32) !important;
}

/* === el-select 输入框(非面板) 深色 === */
:deep(.el-select .el-input__inner) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
:deep(.el-select .el-input__inner::placeholder) { color: #7f93a2 !important; }
:deep(.el-select .el-input.is-focus .el-input__inner),
:deep(.el-select .el-input__inner:focus) {
  border-color: rgba(163,255,18,0.42) !important;
  box-shadow: 0 0 0 1px rgba(163,255,18,0.12) inset !important;
}
/* 下拉箭头颜色 */
:deep(.el-select .el-input__suffix .el-select__caret) { color: #e2f0ff !important; }

/* === 分页整体深色，页号为黑客绿风格 === */
:deep(.el-pagination) { color: #e2f0ff; }

/* 上一页/下一页按钮 */
:deep(.el-pagination .btn-prev),
:deep(.el-pagination .btn-next) {
  background: rgba(255,255,255,0.04) !important;
  border: 1px solid rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
  border-radius: 8px !important;
}
:deep(.el-pagination .btn-prev:disabled),
:deep(.el-pagination .btn-next:disabled) {
  opacity: 0.5 !important;
}

/* 数字页码按钮 */
:deep(.el-pagination .el-pager li) {
  background: rgba(255,255,255,0.04) !important;
  border: 1px solid rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
  border-radius: 8px !important;
  margin: 0 2px !important;
  min-width: 32px !important;
}
:deep(.el-pagination .el-pager li:not(.disabled):hover) {
  background: rgba(163,255,18,0.08) !important;
  border-color: rgba(163,255,18,0.28) !important;
}
:deep(.el-pagination .el-pager li.active) {
  background: #16a34a !important;     /* 黑客绿激活 */
  border-color: #16a34a !important;
  color: #0b1320 !important;          /* 深色前景 */
}

/* 跳转输入框（有的话） */
:deep(.el-pagination__editor .el-input__inner) {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}

</style>

<style>
/* 深色 MessageBox：只作用于申请补车用到的 this.$confirm（customClass: 'apoc-confirm'） */
.apoc-confirm.el-message-box {
  background-color: rgba(11, 19, 32, 0.96) !important; /* 你的深色基底 */
  color: #e2f0ff !important;
  border: 1px solid rgba(255,255,255,0.06) !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5) !important;
}
.apoc-confirm .el-message-box__header {
  background: transparent !important;
  border-bottom: 1px dashed rgba(255,255,255,0.08) !important;
}
.apoc-confirm .el-message-box__title { color: #e2f0ff !important; }
.apoc-confirm .el-message-box__content { color: #a9bac6 !important; }
.apoc-confirm .el-message-box__headerbtn .el-message-box__close { color: #9fb0bf !important; }
.apoc-confirm .el-message-box__footer {
  background: transparent !important;
  border-top: 1px dashed rgba(255,255,255,0.08) !important;
}

/* 输入框在确认框内也保持深色（如果有） */
.apoc-confirm .el-input__inner {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}

/* 按钮深色（与你全站按钮风格一致） */
.apoc-confirm .el-button {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
.apoc-confirm .el-button:hover,
.apoc-confirm .el-button:focus {
  background: rgba(163,255,18,0.08) !important;
  border-color: rgba(163,255,18,0.28) !important;
}
.apoc-confirm .el-button--primary {
  background: #16a34a !important;      /* 你的绿色主色 */
  border-color: #16a34a !important;
  color: #0b1320 !important;
}
.apoc-confirm .el-button--primary:hover,
.apoc-confirm .el-button--primary:focus {
  filter: brightness(1.1);
  border-color: #22c55e !important;
}
.apoc-confirm .el-button--primary:focus,
.apoc-confirm .el-button--primary.is-focus,
.apoc-confirm .el-button--primary:focus:not(:hover),
.apoc-confirm .el-button--primary:focus:not(.hover) {
  background: #16a34a !important;   /* 和正常态保持一致 */
  border-color: #16a34a !important;
  color: #0b1320 !important;
  filter: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 普通按钮在焦点态也保持深色正常态（可选） */
.apoc-confirm .el-button:focus {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
  box-shadow: none !important;
  outline: none !important;
}
.el-select-dropdown {
  background: #101826 !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
.el-select-dropdown__wrap { background: transparent !important; }
.el-select-dropdown__item { color: #e2f0ff !important; }
.el-select-dropdown__item.hover,
.el-select-dropdown__item.selected {
  background: rgba(163,255,18,0.12) !important;
}
/* popper 箭头颜色避免违和 */
.el-popper[x-placement^="bottom"] .popper__arrow,
.el-popper[x-placement^="top"] .popper__arrow {
  border-color: rgba(255,255,255,0.12) transparent !important;
}

/* === 申请补车确认框 深色（customClass: 'apoc-confirm'）=== */
.apoc-confirm.el-message-box {
  background-color: rgba(11, 19, 32, 0.96) !important;
  color: #e2f0ff !important;
  border: 1px solid rgba(255,255,255,0.06) !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5) !important;
}
.apoc-confirm .el-message-box__header {
  background: transparent !important;
  border-bottom: 1px dashed rgba(255,255,255,0.08) !important;
}
.apoc-confirm .el-message-box__title { color: #e2f0ff !important; }
.apoc-confirm .el-message-box__content { color: #a9bac6 !important; }
.apoc-confirm .el-message-box__headerbtn .el-message-box__close { color: #9fb0bf !important; }
.apoc-confirm .el-message-box__footer {
  background: transparent !important;
  border-top: 1px dashed rgba(255,255,255,0.08) !important;
}
/* 按钮保持深色 */
.apoc-confirm .el-button {
  background: rgba(255,255,255,0.04) !important;
  border-color: rgba(255,255,255,0.12) !important;
  color: #e2f0ff !important;
}
.apoc-confirm .el-button:hover,
.apoc-confirm .el-button:focus {
  background: rgba(163,255,18,0.08) !important;
  border-color: rgba(163,255,18,0.28) !important;
}
.apoc-confirm .el-button--primary {
  background: #16a34a !important;
  border-color: #16a34a !important;
  color: #0b1320 !important;
}
/* 取消“默认聚焦高亮”带来的假选中感（上次说的修复） */
.apoc-confirm .el-button--primary:focus,
.apoc-confirm .el-button--primary.is-focus,
.apoc-confirm .el-button--primary:focus:not(:hover),
.apoc-confirm .el-button--primary:focus:not(.hover) {
  background: #16a34a !important;
  border-color: #16a34a !important;
  color: #0b1320 !important;
  filter: none !important;
  box-shadow: none !important;
  outline: none !important;
}
</style>

<style>
.profile-page .profile-home-logo {
  display: block;
  width: 116px;
  height: 30px;
  object-fit: contain;
  object-position: left center;
  cursor: pointer;
  flex: 0 0 auto;
  margin-left: 18px;
  margin-right: 8px;
}
.profile-page .page-header { min-height: 54px !important; overflow: hidden; }
.profile-page .page-header > .right { margin-right: 34px !important; gap: 16px !important; }
.profile-page .page-header > .right .el-button,
.profile-page .logout-btn {
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  color: #fff !important;
}
.profile-page .page-header > .right .el-button:hover,
.profile-page .logout-btn:hover { color: #f5a834 !important; background: transparent !important; }
.profile-page .points-display,
.profile-page .points-display--diamonds,
.profile-page .spi-points,
.profile-page .spi-diamonds {
  border: 0 !important;
  background: #f5a834 !important;
  color: #111 !important;
  box-shadow: none !important;
}
.profile-page .points-display .pd-title { color: #eee9dc !important; opacity: 1 !important; }
.profile-page .points-display .pd-value { color: #f5a834 !important; }
.profile-page .points-display {
  display: flex !important;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.profile-page .points-display .pd-title,
.profile-page .points-display .pd-value { line-height: 1.15 !important; }
.profile-page .server-points,
.profile-page .sp-item,
.profile-page .orders-card,
.profile-page .locked-mask,
.profile-page .lock-box { border-color: transparent !important; background-color: #1e1e1e !important; }
.profile-page .lock-actions .el-button { background: #f5a834 !important; border: 0 !important; color: #111 !important; }
.profile-page .sp-actions .el-button {
  border-color: #555 !important;
  background: transparent !important;
  color: #fff !important;
}
.profile-page .sp-actions .el-button:hover,
.profile-page .sp-actions .el-button:focus {
  border-color: #f5a834 !important;
  background: #f5a834 !important;
  color: #111 !important;
}
.profile-page .sp-list { margin-top: 8px !important; }
.profile-page .sp-item {
  margin: 0 !important;
  padding: 22px 12px !important;
  border: 0 !important;
  border-bottom: 1px dashed rgba(255,255,255,.12) !important;
  border-radius: 0 !important;
  background: transparent !important;
}
.profile-page .sp-item:last-child { border-bottom: 0 !important; }
.profile-page .sp-item:hover { background: #242424 !important; }
.profile-page .spi-points,
.profile-page .spi-diamonds {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  line-height: 1 !important;
}
.profile-page .orders-card {
  position: relative !important;
  min-height: 170px !important;
  margin-top: 16px !important;
  overflow: hidden !important;
}
.profile-page .locked-mask {
  position: absolute !important;
  inset: 0 !important;
  width: 100% !important;
  min-height: 170px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #1e1e1e !important;
}
.profile-page .lock-box {
  width: auto !important;
  min-width: 220px !important;
  padding: 18px 28px !important;
  background: transparent !important;
  text-align: center !important;
}
.profile-page .apoc-dialog.el-dialog,
.profile-page + .apoc-dialog.el-dialog,
.el-dialog.apoc-dialog {
  background: #1e1e1e !important;
  border: 0 !important;
  color: #eee9dc !important;
}
.el-dialog.apoc-dialog .el-dialog__header,
.el-dialog.apoc-dialog .el-dialog__body,
.el-dialog.apoc-dialog .el-dialog__footer { background: #1e1e1e !important; border-color: transparent !important; }
.el-dialog.apoc-dialog .el-dialog__title { color: #eee9dc !important; }
.el-dialog.apoc-dialog .el-dialog__headerbtn .el-dialog__close { color: #f5a834 !important; }
.el-dialog.apoc-dialog .el-button--primary { background: #f5a834 !important; border: 0 !important; color: #111 !important; }
</style>
